import * as React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import InfoIcon from 'assets/images/InfoIcon.svg';
import NormalButton from 'components/system/atoms/buttons/NormalButton';
import OutlineTextBox from 'components/system/atoms/textBoxs/OutlineTextBox';
import { REST_API } from 'constants/apiUrls';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import HttpConnection from 'utils/httpConnection';
import { handleCallFrontError } from 'redux/slices/commonSlice';
import MessageHelper from 'utils/message.helper';
import MSG from 'constants/messages';

/* ************ Style ************ */
const useStyles = makeStyles()((theme) => ({
  paper: {
    backgroundColor: theme.palette.common.black,
    minHeight: '380px',
    width: '640px',
  },
  content: {
    alignItems: 'start',
    padding: '40px 8px 0px 40px ',
  },
  contentTop: {
    display: 'flex',
  },
  defaultBox: {
    margin: '8px 0 0 24px',
  },
  defaultText: {
    color: theme.palette.common.white,
    whiteSpace: 'pre-line',
    wordWrap: 'break-word',
    fontSize: '21px',
    marginBottom: '16px',
    
  },
  action: {
    padding: '0px 40px 16px 40px ',
    display: 'flex',
    justifyContent: 'space-between',
  },
  detailmsg: {
    color: theme.palette.common.white,
    fontSize: 24,
    overflow: 'hidden',
  },
  buttonIcon: {
    height: 80,
    width: 200,
    fontSize: 28,
    borderRadius: 12,
  },
  buttonOk: {
    backgroundColor: '#FF3E3E',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#FF3E3E',
    },
    '&:active': {
      backgroundColor: '#FF7070',
    },
  },
  buttonCancel: {
    backgroundColor: '#BCBCBC',
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: '#BCBCBC',
    },
    '&:active': {
      backgroundColor: '#D3D3D3',
    },
  },
  passSetting: {
    color: theme.palette.common.white,
    fontSize: 24,
    marginTop: '12px',
  },
  passText: {
    width: '100%',
  },
  pass: {
    width: '95%'
  },
}));

type DialogProps = {
  open: boolean;
  msg: string;
  detailMsg?: string;
  okBtnLabel?: string;
  cancelBtnLabel?: string;
  onOk: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
  addClass?: {
    contentBox?: string;
    contentText?: string;
  };
  userId?: string;
  versionNo?: number;
};

const EmailClearDialog: React.FC<React.PropsWithChildren<DialogProps>> = ({
  open,
  msg,
  detailMsg,
  onOk,
  okBtnLabel = 'はい',
  onCancel,
  cancelBtnLabel = 'いいえ',
  children,
  addClass,
  userId,
  versionNo
}) => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const [password, setPassword] = React.useState<string>('');
  const myUserInfo = useAppSelector((state) => state.common.userInfo);

  /* ************ Event ************ */
  const handleChangePasswordInput = (ev: React.ChangeEvent<HTMLInputElement>): void => {
    // Handle input change
    setPassword(ev.target.value);
  }

  /* ************ API ************ */
  const handleOk = async() => {
    // パスワードが空の場合はエラー
    if (password === '') {
      dispatch(handleCallFrontError({errors: { key: [MessageHelper.messageFormat(MSG.INF119)] },}),);
      return; // バリデーションエラーの場合は false を返す
    }
    const http = new HttpConnection({ dispatch });
    await http
      .post<boolean>(REST_API.MAINTENANCE.CLEAR_EMAIL, {userId: userId, password: password, myUserId: myUserInfo?.userId, versionNo: versionNo})
      .then((data) => {
          if (data) {
            setPassword('');
            onOk();
          }
      });
  };
  return (
    <Dialog
        classes={{
          paper: classes.paper,
        }}
        open={open}
        onClose={onCancel}
        maxWidth={false}>
        <DialogContent
          classes={{
            root: classes.content,
          }}>
          <Box className={classes.contentTop}>
            <img src={InfoIcon} alt="Info" />
            <Box className={`${classes.defaultBox} ${addClass?.contentBox}`}>
              <DialogContentText className={`${classes.defaultText}`}>
                {msg}
              </DialogContentText>
              {detailMsg && (
                <DialogContentText
                  classes={{
                    root: classes.detailmsg,
                  }}>
                  {detailMsg}
                </DialogContentText>
              )}
              {children}
            </Box>
          </Box>
          <Box className={classes.passSetting}>
            <Box className={classes.passText}>確認のためあなたのパスワードを入力してください。</Box>
            <OutlineTextBox
                id="pass"
                name="pass"
                type="password"
                value={password}
                label=""
                fullWidth
                onChange={handleChangePasswordInput}
                className={classes.pass}
            />
          </Box>
        </DialogContent>
        <DialogActions
          classes={{
            root: classes.action,
          }}>
          <NormalButton onClick={handleOk} className={`${classes.buttonIcon} ${classes.buttonOk}`}>
            {okBtnLabel}
          </NormalButton>
          <NormalButton onClick={onCancel} className={`${classes.buttonIcon} ${classes.buttonCancel}`}>
            {cancelBtnLabel}
          </NormalButton>
        </DialogActions>
      </Dialog>
  );
};

export default EmailClearDialog;
